"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _material = require("@mui/material");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _wouter = require("wouter");
var _Style = require("../../style/Style");
var _form = require("../../components/form");
var _common = require("../../store/common");
var _user = require("../../store/user");
var _course = require("../../store/course");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const App = () => {
  const [, setLocation] = (0, _wouter.useLocation)();
  const {
    setToastOpen,
    setToastText,
    setIsLoading,
    setLoadingMessage
  } = (0, _common.useCommonStore)();
  const {
    currentUser,
    newLearner,
    setNewLearner,
    checkNewLearner,
    addNewLearner,
    errors,
    submitting
  } = (0, _user.useUserStore)();
  const {
    courses,
    fetchCourses
  } = (0, _course.useCourseStore)();
  const emailRef = (0, _react.useRef)(null);
  const emailConfirmRef = (0, _react.useRef)(null);
  const passwordRef = (0, _react.useRef)(null);
  const passwordConfirmRef = (0, _react.useRef)(null);
  const isEnableRef = (0, _react.useRef)(null);
  const submitButtonRef = (0, _react.useRef)(null);
  const onLoadingTextChanged = text => {
    setLoadingMessage(text);
  };
  (0, _react.useEffect)(() => {
    (async () => {
      setIsLoading(true);
      await fetchCourses();
      setNewLearner({
        companyId: currentUser.companyId,
        type: 'learner'
      });
      setIsLoading(false);
    })();
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
    container: true,
    ...stylex.props(_Style.wrapper.main),
    spacing: 4,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        ...stylex.props(_Style.buttonStyle.secondary),
        onClick: () => {// setLocation('/admin')
        },
        children: "\uFF1C\u623B\u308B"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
      container: true,
      ...stylex.props(_Style.wrapper.mainTitle),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ...stylex.props(_Style.textStyle.h1),
        children: "\u30E6\u30FC\u30B6\u30FC\u8FFD\u52A0"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
      container: true,
      spacing: 2,
      direction: 'column',
      ...stylex.props(_Style.wrapper.stretchW),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_form.FormFieldInput, {
        label: "\u30E6\u30FC\u30B6\u30FC\u540D",
        type: "text",
        value: newLearner.name,
        errorText: errors.name,
        placeholder: 'ユーザーの名前を入力してください(他のユーザーと重複不可)',
        onChange: event => {
          setNewLearner({
            name: event.target.value
          });
        },
        onEnterKey: () => {
          var _emailRef$current;
          (_emailRef$current = emailRef.current) === null || _emailRef$current === void 0 ? void 0 : _emailRef$current.focus();
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_form.FormFieldInput, {
        label: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
        ref: emailRef,
        type: "text",
        value: newLearner.email,
        errorText: errors.email,
        placeholder: 'メールアドレスを入力してください)',
        onChange: event => {
          setNewLearner({
            email: event.target.value
          });
        },
        onEnterKey: () => {
          var _emailConfirmRef$curr;
          (_emailConfirmRef$curr = emailConfirmRef.current) === null || _emailConfirmRef$curr === void 0 ? void 0 : _emailConfirmRef$curr.focus();
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_form.FormFieldInput, {
        label: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9(\u78BA\u8A8D\u7528)",
        ref: emailConfirmRef,
        type: "text",
        value: newLearner.emailConfirm,
        errorText: errors.emailConfirm,
        placeholder: 'メールアドレス(確認用)を入力してください)',
        onChange: event => {
          setNewLearner({
            emailConfirm: event.target.value
          });
        },
        onEnterKey: () => {
          var _passwordRef$current;
          (_passwordRef$current = passwordRef.current) === null || _passwordRef$current === void 0 ? void 0 : _passwordRef$current.focus();
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_form.FormFieldInput, {
        label: "\u30D1\u30B9\u30EF\u30FC\u30C9",
        ref: passwordRef,
        type: "password",
        value: newLearner.password,
        errorText: errors.password,
        placeholder: 'パスワードを入力してください)',
        onChange: event => {
          setNewLearner({
            password: event.target.value
          });
        },
        onEnterKey: () => {
          var _passwordConfirmRef$c;
          (_passwordConfirmRef$c = passwordConfirmRef.current) === null || _passwordConfirmRef$c === void 0 ? void 0 : _passwordConfirmRef$c.focus();
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_form.FormFieldInput, {
        label: "\u30D1\u30B9\u30EF\u30FC\u30C9(\u78BA\u8A8D\u7528)",
        ref: passwordConfirmRef,
        type: "password",
        value: newLearner.passwordConfirm,
        errorText: errors.passwordConfirm,
        placeholder: 'パスワード(確認用)を入力してください)',
        onChange: event => {
          setNewLearner({
            passwordConfirm: event.target.value
          });
        },
        onEnterKey: () => {
          var _isEnableRef$current;
          (_isEnableRef$current = isEnableRef.current) === null || _isEnableRef$current === void 0 ? void 0 : _isEnableRef$current.focus();
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_form.FormFieldCheckboxes, {
        label: "\u5C65\u4FEE\u3059\u308B\u30B3\u30FC\u30B9",
        items: courses.map(course => {
          var _newLearner$courses;
          return {
            key: course.id,
            label: course.name,
            checked: ((_newLearner$courses = newLearner.courses) === null || _newLearner$courses === void 0 ? void 0 : _newLearner$courses.includes(course.id)) || false
          };
        }),
        values: newLearner.courses,
        errorText: errors.courses,
        placeholder: '履修するコースを選択してください',
        onChecked: (key, checked) => {
          console.log(key, checked);
          if (checked) {
            let courses = newLearner.courses || [];
            courses.push(key);
            setNewLearner({
              courses: courses
            });
          } else {
            let courses = newLearner.courses || [];
            courses = courses.filter(course => course !== key);
            setNewLearner({
              courses: courses
            });
          }
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_form.FormFieldCheckbox, {
        label: "\u6709\u52B9/\u7121\u52B9",
        ref: isEnableRef,
        type: "checkbox",
        checked: newLearner.isEnable,
        errorText: errors.isEnable,
        placeholder: '有効にする',
        onChange: event => {
          const target = event.target;
          setNewLearner({
            isEnable: target.checked
          });
        },
        onEnterKey: () => {
          var _submitButtonRef$curr;
          (_submitButtonRef$curr = submitButtonRef.current) === null || _submitButtonRef$curr === void 0 ? void 0 : _submitButtonRef$curr.focus();
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        ...stylex.props(_Style.buttonStyle.primary),
        disabled: submitting,
        ref: submitButtonRef,
        onClick: async () => {
          setIsLoading(true);
          if (!(await checkNewLearner())) {
            setIsLoading(false);
            return;
          }
          setIsLoading(false);
          alert(newLearner.isEnable);
          if (!window.confirm('ユーザーを追加しますか？')) {
            return;
          }
          setIsLoading(true);
          const result = await addNewLearner(onLoadingTextChanged);
          if (!result) {
            setIsLoading(false);
            return false;
          }
          setToastOpen(true);
          setToastText('ユーザーを追加しました');
          setLocation('/users');
          setIsLoading(false);
          return;
        },
        children: submitting ? 'ユーザー追加中...' : 'ユーザー追加する'
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
        minHeight: 48,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          ...stylex.props(_Style.textStyle.error),
          children: errors.submit
        })
      })]
    })]
  });
};
var _default = exports.default = App;